/* BIANCO — الحركة (GSAP)
   بنستخدم GSAP في اللي الـCSS ماتعرفش تعمله: حركة مربوطة بالسكرول، وظهور
   الكلمات ورا بعض من تحت قناع. أي حاجة تانية سايبينها CSS عشان الصفحة تفضل خفيفة.
   لو الزائر مفعّل "تقليل الحركة" أو GSAP ماحمّلش، الصفحة بتفضل شغالة عادي. */
(function () {
  if (!window.gsap || !window.ScrollTrigger) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  gsap.registerPlugin(ScrollTrigger);

  var q = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // بنلف كل كلمة في علبة مقصوصة عشان تطلع من تحتها
  function words(el) {
    if (!el || el.dataset.bnSplit) return [];
    var txt = (el.textContent || '').trim(); if (!txt) return [];
    el.dataset.bnSplit = '1';
    el.textContent = '';
    txt.split(/\s+/).forEach(function (w, i) {
      var box = document.createElement('span'); box.className = 'bn-w';
      var inner = document.createElement('span'); inner.className = 'bn-wi';
      inner.textContent = w;
      box.appendChild(inner);
      el.appendChild(box);
      if (i < txt.split(/\s+/).length - 1) el.appendChild(document.createTextNode(' '));
    });
    return qa('.bn-wi', el);
  }

  function hero() {
    var sec = q('.bn-banner'); if (!sec) return;
    var img = q('.bn-banner-photo img', sec);
    var box = q('.bn-banner-in', sec);
    var tag = q('.tagline', sec);
    var rest = box ? qa(':scope > *', box).filter(function (x) { return x !== tag; }) : [];
    var ws = words(tag);
    // ضمان إضافي: العنوان لازم يبقى ظاهر حتى لو الـCSS سابه شفاف
    if (tag) gsap.set(tag, { opacity: 1 });

    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
    if (img) tl.fromTo(img, { scale: 1.14, opacity: .3 }, { scale: 1, opacity: 1, duration: 1.7 }, 0);
    if (ws.length) tl.fromTo(ws, { yPercent: 115 }, { yPercent: 0, duration: 1.1, stagger: .09 }, .35);
    if (rest.length) tl.fromTo(rest, { y: 20, opacity: 0 },
      { y: 0, opacity: 1, duration: .8, stagger: .1 }, .55);

    // مربوط بالسكرول: الصورة بتمشي أبطأ وبتكبر شوية، والكلام بيطلع أسرع ويبهت
    if (img) gsap.fromTo(img, { yPercent: 0, scale: 1 }, {
      yPercent: 18, scale: 1.08, ease: 'none',
      scrollTrigger: { trigger: sec, start: 'top top', end: 'bottom top', scrub: .35 }
    });
    if (box) gsap.to(box, {
      y: -90, opacity: .1, ease: 'none',
      scrollTrigger: { trigger: sec, start: 'top top', end: 'bottom top', scrub: .35 }
    });
  }

  // عناوين الأقسام بتتكتب كلمة كلمة أول ما توصلها
  function heads() {
    qa('.sec-head h2, .bn-looks h2, .chead h1').slice(0, 8).forEach(function (h) {
      var ws = words(h); if (!ws.length) return;
      gsap.fromTo(ws, { yPercent: 115 }, {
        yPercent: 0, duration: .95, ease: 'power3.out', stagger: .07,
        scrollTrigger: { trigger: h, start: 'top 88%', once: true }
      });
    });
  }

  // كروت المنتجات بتطلع ورا بعض أول ما توصلها — ScrollTrigger.batch بيجمّعهم
  // عشان ما نعملش مراقب لكل كارت لوحده في صفحة فيها ٢٥٠ قطعة
  var done = [];
  function cards() {
    var els = qa('.card-wrapper, .bn-grid > .pc, #product-grid .grid__item, .ogrid > *')
      .filter(function (el) { return done.indexOf(el) < 0; });
    if (!els.length) return;
    els.forEach(function (el) { done.push(el); });
    gsap.set(els, { opacity: 0, y: 18 });
    ScrollTrigger.batch(els, {
      start: 'top 92%', once: true,
      onEnter: function (batch) {
        gsap.to(batch, { opacity: 1, y: 0, duration: .7, ease: 'power3.out', stagger: .07, overwrite: true });
      }
    });
    // اللي فوق الشاشة من الأول يبان على طول
    ScrollTrigger.refresh();
  }

  // شريط البراندات: بيتسارع مع سرعة السكرول ويرجع لسرعته لوحده
  function rail() {
    qa('.rail-t, .bn-top-t').forEach(function (t) {
      var secs = t.classList.contains('rail-t') ? 56 : 36;
      var rtl = document.documentElement.getAttribute('dir') === 'rtl';
      var tw = gsap.to(t, { xPercent: rtl ? 50 : -50, duration: secs, ease: 'none', repeat: -1 });
      var back = null;
      ScrollTrigger.create({
        onUpdate: function (self) {
          var v = Math.min(Math.abs(self.getVelocity()) / 900, 5);
          tw.timeScale(1 + v);
          if (back) back.kill();
          back = gsap.to(tw, { timeScale: 1, duration: .9, ease: 'power2.out', overwrite: true });
        }
      });
    });
  }

  function start() { hero(); heads(); cards(); rail(); ScrollTrigger.refresh(); }
  // الصفحات اللي بترسم منتجاتها بجافاسكربت بتنادي الحدث ده بعد ما تحدّث
  document.addEventListener('bn:live', function () { setTimeout(cards, 60); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', function () { ScrollTrigger.refresh(); });
})();
